<template>
  <div class="my-log-picker">
    <mt-popup
      v-model="isShow"
      position="center"
      popup-transition="popup-fade"
      style="width: 90%; padding: 0.2rem; border-radius: 0.2rem"
      :closeOnClickModal="false"
      v-clickoutside="closePopup"
    >
      <span class="m-log-title">查看物流</span>
      <div
        @click="jumpTo(index)"
        v-for="(item, index) in delivery"
        :key="index"
      >
        <mt-cell :title="item.express_name" is-link></mt-cell>
      </div>
    </mt-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    isShow: false,
    delivery: [],
    toAddress: {},
  },
  methods: {
    closePopup() {
      this.$emit("update:isShow", false);
    },
    jumpTo(index) {
      const { delivery, toAddress } = this;
      const { delivery_no, express_no } = delivery[index];
      const { mobile } = toAddress;
      this.$router.push({
        path: "mlogisti",
        query: { delivery_no, express_no, mobile },
      });
    },
  },
};
</script>


<style>
.m-log-title {
  font-size: 0.34rem;
  font-weight: bold;
  text-align: center;
  display: block;
  width: 100%;
  padding-bottom: 0.2rem;
}
</style>


// WEBPACK FOOTER //
// src/pages/mobile/components/MyLogPicker/index.vue